import React from 'react';
import styled from 'styled-components';
import ComponentGroupHeading from '../ComponentGroupHeading';
import ImpactStoryJumbotron from '../ImpactStoryJumbotron';
import Paragraph from '../Paragraph';
import BigImage from '../BigImage';
import ScrollableContent from '../ScrollableContent';

const FullWidthWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  min-height: 600px;
`;

const Decorations = styled.div`
  min-width: 30px;
  flex: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (${({ theme }) => theme.mq.l}) {
    min-width: 100px;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const DecorativeCircle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #1924c2;
  margin-left: -23px;
  position: relative;
  z-index: 9999999;

  @media (${({ theme }) => theme.mq.l}) {
    margin-left: -58px;
  }
`;

const DecorativeLine = styled.div`
  position: absolute;
  height: 100%;
  width: 0px;
  border: 1px solid #1924c2;
`;

const FullWidthAdjuster = styled.div`
  margin-left: -60px;

  @media (${({ theme }) => theme.mq.l}) {
    margin-left: -130px;
  }
`;

function ComponentGroup({ groupedComponents }) {
  return (
    <FullWidthWrapper>
      <Decorations>
        <DecorativeLine />
      </Decorations>
      <Content>
        {groupedComponents.map((component) => {
          if (component.__typename === 'ContentfulComponentGroupHeading') {
            return (
              <div key={component.id}>
                <DecorativeCircle />
                <ComponentGroupHeading {...component} />
              </div>
            );
          } if (component.__typename === 'ContentfulParagraph') {
            return <Paragraph key={component.id} {...component} />;
          } if (
            component.__typename === 'ContentfulImpactStoryJumbotron'
          ) {
            return <ImpactStoryJumbotron key={component.id} {...component} />;
          } if (component.__typename === 'ContentfulBigImage') {
            return (
              <FullWidthAdjuster key={component.id}>
                <BigImage {...component} />
              </FullWidthAdjuster>
            );
          } if (component.__typename === 'ContentfulScrollableContent') {
            return (
              <FullWidthAdjuster key={component.id}>
                <ScrollableContent {...component} />
              </FullWidthAdjuster>
            );
          }
          return null;
        })}
      </Content>
    </FullWidthWrapper>
  );
}

export default ComponentGroup;
